import React from "react";
import { GridLegacy, MenuItem, Paper, Select, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import SelectType from "./SelectType";
import { apiProviders } from "../variables/app";

function ConditionsSet({ conditions, setIndex, onDeleteSet, setPermissions }) {
  return (
    <Paper style={{ margin: 8, border: "1px solid black" }}>
      <GridLegacy container>
        <GridLegacy item xs={12}>
          <Typography style={{ fontWeight: 800 }}>Set {setIndex + 1}</Typography>
          <Button
            onClick={() => {
              onDeleteSet();
            }}
            size={"small"}
            variant={"outlined"}
          >
            Delete Set
          </Button>
          <Button
            onClick={() => {
              const defaultConditionType = sessionStorage.getItem("defaultConditionType") ?? "SOLUTION";
              let defaultConditionValue = sessionStorage.getItem("defaultConditionValue") ?? "QR";
              if (defaultConditionType === "OR") {
                defaultConditionValue = [];
              }
              conditions.push({ type: defaultConditionType, value: defaultConditionValue });
              setPermissions();
            }}
            size={"small"}
            variant={"outlined"}
          >
            Add new condition
          </Button>
        </GridLegacy>
        {conditions.map((condition, conditionIndex) => {
          switch (condition.type) {
            case "OR":
              return (
                <>
                  <GridLegacy item xs={1}>
                    <SelectType
                      onChange={(type, value) => {
                        conditions.splice(conditionIndex, 1, { type: type, value: value });
                        setPermissions();
                      }}
                      value={condition.type}
                    />
                  </GridLegacy>
                  <GridLegacy item xs={9}>
                    <ConditionsSet
                      conditions={condition.value}
                      onDeleteSet={() => {
                        conditions.splice(conditionIndex, 1);
                        setPermissions();
                      }}
                      setIndex={0}
                      setPermissions={() => {
                        setPermissions();
                      }}
                    />
                  </GridLegacy>
                </>
              );
            case "SOLUTION":
              return (
                <>
                  <GridLegacy item xs={1}>
                    #{conditionIndex + 1}
                  </GridLegacy>
                  <GridLegacy item xs={4}>
                    <SelectType
                      onChange={(type, value) => {
                        conditions.splice(conditionIndex, 1, { type: type, value: value });
                        setPermissions();
                      }}
                      value={condition.type}
                    />
                  </GridLegacy>

                  <GridLegacy item xs={2} />

                  <GridLegacy item xs={3}>
                    <Select
                      onChange={(e) => {
                        sessionStorage.setItem("defaultConditionValue", e.target.value);
                        conditions[conditionIndex].value = e.target.value;
                        setPermissions();
                      }}
                      value={condition.value}
                    >
                      {["QR", "KIOSK", "PICKUP_DELIVERY", "TABLET", "CATALOG"].map((role) => {
                        return (
                          <MenuItem key={role} value={role}>
                            {role}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <Button
                      onClick={() => {
                        conditions.splice(conditionIndex, 1);
                        setPermissions();
                      }}
                    >
                      Delete Condition
                    </Button>
                  </GridLegacy>
                </>
              );
            case "POS":
              return (
                <>
                  <GridLegacy item xs={1}>
                    #{conditionIndex + 1}
                  </GridLegacy>
                  <GridLegacy item xs={4}>
                    <SelectType
                      onChange={(type, value) => {
                        conditions.splice(conditionIndex, 1, { type: type, value: value });
                        setPermissions();
                      }}
                      value={condition.type}
                    />
                  </GridLegacy>

                  <GridLegacy item xs={2} />

                  <GridLegacy item xs={3}>
                    <Select
                      onChange={(e) => {
                        conditions.splice(conditionIndex, 1, {
                          type: "POS",
                          value: e.target.value,
                        });

                        sessionStorage.setItem("defaultConditionValue", e.target.value);
                        setPermissions();
                      }}
                      value={condition.value}
                    >
                      {apiProviders
                        .sort((a, b) => a.label.localeCompare(b.label))
                        .map((pos) => {
                          return (
                            <MenuItem key={pos.value} value={pos.value}>
                              {pos.label}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </GridLegacy>
                  <GridLegacy item xs={2}>
                    <Button
                      onClick={() => {
                        conditions.splice(conditionIndex, 1);
                        setPermissions();
                      }}
                    >
                      Delete Condition
                    </Button>
                  </GridLegacy>
                </>
              );
          }
          return (
            <>
              <GridLegacy item xs={1}>
                #{conditionIndex + 1}
              </GridLegacy>
              <GridLegacy item xs={4}>
                Type: {condition.type}
              </GridLegacy>

              <GridLegacy item xs={2}>
                Operator: {condition.operator}
              </GridLegacy>

              <GridLegacy item xs={3}>
                Value: {condition.value}
              </GridLegacy>
              <GridLegacy item xs={2}>
                <Button
                  onClick={() => {
                    conditions.splice(conditionIndex, 1);
                    setPermissions();
                  }}
                >
                  Delete Condition
                </Button>
              </GridLegacy>
            </>
          );
        })}
      </GridLegacy>
    </Paper>
  );
}

export default ConditionsSet;
